import mail from 'app/entities/mail/mail.reducer';
import mailType from 'app/entities/mail-type/mail-type.reducer';
import mailGroup from 'app/entities/mail-group/mail-group.reducer';
import depositTransaction from 'app/entities/deposit-transaction/deposit-transaction.reducer';
import order from 'app/entities/order/order.reducer';
import bank from 'app/modules/administration/bank/bank.reducer';
/* jhipster-needle-add-reducer-import - JHipster will add reducer here */

const entitiesReducers = {
  mail,
  mailType,
  mailGroup,
  depositTransaction,
  order,
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
};

export default entitiesReducers;
